import React, {  useCallback, useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';

import RestrictedInput from 'ati-ui-react/components/RestrictedInput';
import { useLocalized } from 'utils/useLocalized';

import styles from './styles.modules.scss';
import i18nStrings from './strings';

const numbersOnlyRestriction = 1;

const RangeNumbersInputs = ({title, after, valueFrom, valueTo, onChangeFrom, onChangeTo}) => {
    const strings = useLocalized(i18nStrings);
    const [from, setFrom] = useState(valueFrom);
    const [to, setTo] = useState(valueTo);

    useEffect(() => {
        if (valueTo !== to) setTo(valueTo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueTo]);

    useEffect(() => {
        if (valueFrom !== from) setFrom(valueFrom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueFrom]);

    const handleFromChange = useCallback((event) => setFrom(parseInt(event.target.value, 10) || null), []);
    const handleToChange = useCallback((event) => setTo(parseInt(event.target.value, 10) || null), []);

    const handleOnBlurFrom = useCallback(() => onChangeFrom(from), [from, onChangeFrom]);
    const handleOnBlurTo = useCallback(() => onChangeTo(to), [to, onChangeTo]);

    return (
        <div className={styles['element']}>
            <div className={styles['title']}>
                {title}
            </div>
            <span className={styles['inputs']}>
                <RestrictedInput
                    after={after}
                    inputRestriction={numbersOnlyRestriction}
                    maxLength={4}
                    placeholder={strings.from}
                    type="text"
                    value={from}
                    wrapperClassName={styles['from-input']}
                    onBlur={handleOnBlurFrom}
                    onChange={handleFromChange}
                />
                <RestrictedInput
                    after={after}
                    inputRestriction={numbersOnlyRestriction}
                    maxLength={4}
                    placeholder={strings.to}
                    type="text"
                    value={to}
                    wrapperClassName={styles['to-input']}
                    onBlur={handleOnBlurTo}
                    onChange={handleToChange}
                />
            </span>
        </div>
    );
};

export default RangeNumbersInputs;

RangeNumbersInputs.propTypes = {
    after: PropTypes.node,
    title: PropTypes.string,
    valueFrom: PropTypes.number,
    valueTo: PropTypes.number,
    onChangeFrom: PropTypes.func,
    onChangeTo: PropTypes.func,
};
